import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiProcedimientosService } from '../../../services/api-procedimientos.service';
import { Globals } from '../../../globals';

declare var $: any;

@Component({
  selector: 'app-padron-proveedores',
  templateUrl: './padron-proveedores.component.html',
  styleUrls: ['./padron-proveedores.component.css']
})
export class PadronProveedoresComponent implements OnInit {

  pantalla = 2;
  anio = Number(new Date().getFullYear());
  proveedor;

  registros: any [] = [];

  constructor(private router: Router, private apiProc: ApiProcedimientosService, public globals: Globals) {
  }

  ngOnInit() {

    $('#mod_procesando').modal('show');
    this.cargaDatos();
  }


  cargaDatos() {
    this.apiProc.getPadronProveedores().subscribe(data => {
      if (data[0].success) {
        if(data[0].info !== '{}' && data[0].info  !== '[]'){
           let datos = JSON.parse(data[0].info);
           this.registros = datos;

           /*setTimeout( () => {
            $('#mod_procesando').modal('hide');
          }, 400);*/

        } else {
          setTimeout( () => {
            $('#mod_procesando').modal('hide');
          }, 400);
        }
      } else {
        setTimeout( () => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 400);
      }



      this.cargaDatatable();
    },
    error => {
      setTimeout( () => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }


  cargaDatatable() {

    $(document).ready(function () {
      if ($.fn.dataTable.isDataTable('#tbl_Padron')) {
        $('#tbl_Padron').DataTable().destroy();
    }
      /*Clona la tabla obtenida a otra sin generar DataTable, para que al exportar no tenga conflictos en la vista.*/
      $('#tablaExcelProc').empty();
      $('#tbl_Padron').clone().appendTo('#tablaExcelProc');

      $('#tablaExcelProc th').css('background-color', '#9DB9E5');

      $('#tablaExcelProc td.table-success').css('background-color', '#c3e6cb');

      $('#tablaExcelProc tr.table-info').css('background-color', '#c3e6e6');

      $('#tablaExcelProc th').css('border', '#C0C0C0 solid 1px');
      $('#tablaExcelProc td').css('border', '#C0C0C0 solid 1px');

      let datatable = $('#tbl_Padron').DataTable({
        //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
        buttons: [
            /*{
                extend: 'excelHtml5',
                autoFilter: true,
                createEmptyCells: true,
                footer: true,
                text: '<i class="mdi mdi-file-export mr-2"></i>EXPORTAR',
                className: 'btn btn-sm uaa-btn-outline',

                exportOptions: {
                    orthogonal: 'export',
                    columns: [0, 1, 2, 3, 4, 5]
                },
                sheetName:"Proveedores",
                customize: function( xlsx ) {
                  var sheet = xlsx.xl.worksheets['sheet1.xml'];
                  var styles = xlsx.xl['styles.xml'];


          $('row:eq(1) c', sheet).attr('s', '67');


              },
                title: 'PADRÓN DE PROVEEDORES',

                filename: 'Padron_Proveedores'
            },*/

                        {
                            text: '<i class="mdi mdi-file-export mr-2"></i> EXPORTAR',
                            id: "btn_Agregar",
                            className: 'btn btn-primary',
                            action: function () {

                              var a = document.createElement('a');
                              var data_type = 'data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF';
                              a.href = data_type + ' ' + encodeURIComponent(
                                  $('div[id$=tablaExcelEncabezado]').html() +
                                  $('div[id$=tablaExcelEspacio]').html() +
                                  $("#tablaExcelProc").html() +
                                  $('div[id$=tablaExcelEspacio]').html()
                              );
                              a.download = 'PADRON_PROVEEDORES.xls';
                              a.click();
                            }
                        },
            {
                extend: 'pageLength',
                className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
            }
        ]
      });

      $('#inputBusqueda').on( 'keyup', function () {
        datatable.search( this.value ).draw();

      });

      setTimeout( () => {
        $('#mod_procesando').modal('hide');
      }, 400);

      });

  }


}
